import { render, staticRenderFns } from "./ReadOnlyBundle.vue?vue&type=template&id=b775c720&"
import script from "./ReadOnlyBundle.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports